/**
 * @author：
 * @update：
 * @description：
 **/
import {goodsTypeList,addType,goodsTypeGroupingList,goodsTypeGroupingAdd,goodsTypeDetail,goodsTypeEdit,goodsTypeDel} from '../../api/url'
import CusPagination from '@/components/cusPagination.vue';
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            tableData: [],
            page: 1,
            size: 10,
            count:0,
            //新增商品类型
            addGoodsType:false,//新增商品类型弹窗
            addGoodsTypeEditBol:false,//新增商品类型是否为编辑页面
            addGoodsTypeEditId:'',//新增商品类型编辑的id
            typeName:'',//类型名称
            groupingList:[],//属性分组
            enable:true,//启禁用

            //商品属性分组
            goodsTypeGrouping:false,//商品属性分组弹窗
            goodsTypeGroupingEditBol:false,//商品属性分组是否编辑
            goodsTypeGroupingEditId:'',//商品属性分组编辑id
            goodsTypeGroupingName:'',//商品属性分组名称
            searchName:'',//搜索的属性名称
            searchList:[],//搜索数据
            searchActiveList:[],//选择的数据
            goodsTypeGroupingPage:1,//搜索数据分页
            goodsTypeGroupingSize:5,//搜索数据个数
            goodsTypeGroupingCount:0,//搜索数据总数

            //新增商品属性
            addGoodsAttributes:false,//新增商品属性弹窗
            goodsAttributesName:'',//新增商品属性名称
            goodsAttributesVal:[{name:''}],//新增商品属性内容
            goodsAttributesRadio:"RADIO",//选择形式
            textTypeValue:'STRING',//输入框类型
            minVal:'',//最小值
            maxVal:'',//最大值
            unit:'',//单位
            unlimited:false,//是否显示无限制
        };
    },
    // 自定义方法
    methods: {
        /*新增商品类型*/
        //新增商品类型提交/保存
        addGoodsTypeBtn(){
            if(this.typeName==''){
                this.$message({
                    showClose:true,
                    message:"请填写类型名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.groupingList.length==0){
                this.$message({
                    showClose:true,
                    message:"请添加商品属性分组",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            let data = {
                name:this.typeName,
                enabled:this.enable
            };
            let arr = [];
            for(let i = 0; i < this.groupingList.length; i++){
                let obj = {};
                obj.name = this.groupingList[i].name;
                if(this.groupingList[i].id){//编辑时带上id
                    obj.id =  this.groupingList[i].id;
                }
                let arr2 = [];
                for(let j = 0; j < this.groupingList[i].data.length; j++){
                    let obj2 = {};
                    obj2.attributeTemplate ={id:this.groupingList[i].data[j].id};
                    obj2.searchable = this.groupingList[i].data[j].search;
                    obj2.optional = this.groupingList[i].data[j].select;
                    arr2.push(obj2)
                }
                obj.groupTemplates = arr2;
                arr.push(obj)
            }
            data.attributeGroups = arr;
            if(this.addGoodsTypeEditBol==false){
                //新增
                this.$ajax.post(addType,data).then(res=>{
                    console.log(res);
                    this.addGoodsTypeClose();//关闭弹窗并清空
                    this.dataList();//刷新列表
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }else{
                //编辑
                data.id = this.addGoodsTypeEditId;
                this.$ajax.put(goodsTypeEdit(this.addGoodsTypeEditId),data).then(res=>{
                    console.log(res);
                    this.addGoodsTypeClose();//关闭弹窗并清空
                    this.dataList();//刷新列表
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                })
            }
        },
        //新增商品类型取消
        addGoodsTypeClose(){
            this.typeName = '';
            this.groupingList = [];
            this.addGoodsType = false;
        },
        //新增商品类型编辑详情
        addGoodsTypeEdit(id){
            this.addGoodsTypeEditId = id;
            this.$ajax.get(goodsTypeDetail(id),{id:id}).then(res=>{
                console.log(res);
                this.addGoodsType = true;
                this.typeName = res.data.name;
                let arr = [];
                for(let i = 0; i < res.data.attributeGroups.length; i++){
                    let obj = {};
                    obj.name = res.data.attributeGroups[i].name;
                    obj.id = res.data.attributeGroups[i].id;
                    let arr2 = [];
                    for(let j = 0; j < res.data.attributeGroups[i].groupTemplates.length; j++){
                        let obj2 = {};
                        obj2.select = res.data.attributeGroups[i].groupTemplates[j].optional;
                        obj2.search = res.data.attributeGroups[i].groupTemplates[j].searchable;
                        obj2 = {...obj2,...res.data.attributeGroups[i].groupTemplates[j].attributeTemplate}
                        arr2.push(obj2)
                    }
                    obj.data = arr2;
                    arr.push(obj)
                }
                this.groupingList  = arr;
                this.enable = res.data.enabled;
                this.addGoodsTypeEditBol = true;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //新增商品类型删除
        addGoodsTypeDel(id){
            this.$ajax.delete(goodsTypeDel(id)).then(res=>{
                console.log(res);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.dataList();//刷新列表
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //新增商品类型属性分组删除
        addGoodsTypeListDel(index){
            this.$confirm('此操作将删除该分组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let arr = this.groupingList;
                arr.splice(index,1);
                this.groupingList = arr;
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {

            });
        },
        //新增商品类型属性分组编辑
        addGoodsTypeListEdit(item){
            this.goodsTypeGroupingEditId = item.id;
            this.goodsTypeGrouping = true;
            this.goodsTypeGroupingEditBol = true;
            this.goodsTypeGroupingData();
            this.goodsTypeGroupingName = item.name;
            this.searchActiveList = [...item.data];
        },

        /*新增/编辑商品属性分组*/
        //新增/编辑商品属性分组数据
        goodsTypeGroupingData(){
            let data = {
                name:this.searchName,
                enabled:true,
                pageNumber:this.goodsTypeGroupingPage,
                pageSize:this.goodsTypeGroupingSize
            }
            this.$ajax.get(goodsTypeGroupingList,data).then(res=>{
                console.log(res);
                for(let i = 0; i < res.data.rows.length; i++){
                    if(this.searchActiveList.length>0){
                        for(let j = 0; j < this.searchActiveList.length; j++){
                            if(res.data.rows[i].id==this.searchActiveList[j].id){
                                res.data.rows[i].bol = true;
                                break
                            }else{
                                res.data.rows[i].bol = false
                            }
                        }
                    }else{
                        res.data.rows[i].bol = false
                    }

                }
                this.searchList = res.data.rows;
                this.goodsTypeGroupingCount = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //新增/编辑商品属性分组数据选择
        addGoodsAttributesSelect(data,index){
            let arr = this.searchActiveList;
            arr.push(data);
            this.searchActiveList = arr;
            let arr2 = this.searchList;
            arr2[index].bol = true;
            this.searchList = arr2
        },
        //新增/编辑商品属性分组选择数据删除
        addGoodsAttributesDel(data,index){
            let arr = this.searchActiveList;
            arr.splice(index,1);
            let arr2 = this.searchList;
            for(let i = 0; i < arr2.length; i++){
                if(data.id==arr2[i].id){
                    arr2[i].bol = false;
                    break
                }
            }
            this.searchList = arr2
        },
        //新增/编辑商品属性分组选择数据清空
        empty(){
            this.searchActiveList = [];
            let arr2 = this.searchList;
            for(let i = 0; i < arr2.length; i++){
                arr2[i].bol = false;
            }
            this.searchList = arr2
        },
        //新增/编辑商品属性分组数据提交
        goodsTypeGroupingBtn(){
            if(this.goodsTypeGroupingName==''){
                this.$message({
                    showClose:true,
                    message:"请填写商品属性分组名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.searchActiveList.length==0){
                this.$message({
                    showClose:true,
                    message:"请选择分组属性",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            let dataList = this.searchActiveList;
            if(this.goodsTypeGroupingEditBol==false){
                //新增提交
                for(let i = 0; i < dataList.length; i++){
                    dataList[i].search = false;
                    dataList[i].select = true;
                }
                let arr = this.groupingList;
                arr.push({name:this.goodsTypeGroupingName,data:dataList});
                this.groupingList = [...arr];
            }else{
                //编辑提交
                for(let i = 0; i < dataList.length; i++){
                    if(dataList[i].search==undefined){
                        dataList[i].search = false;
                    }
                    if(dataList[i].select==undefined){
                        dataList[i].select = true;
                    }
                }
                let arr = [...this.groupingList];
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].id == this.goodsTypeGroupingEditId){
                        arr[i] = {name:this.goodsTypeGroupingName,data:dataList}
                    }
                }
                this.groupingList = [...arr];
            }
            this.groupingList = [...this.groupingList]
            this.goodsTypeGroupingClose();
        },
        //强制更新视图
        forceRefresh(){
            this.$forceUpdate()
        },
        //新增/编辑商品属性分组数据取消
        goodsTypeGroupingClose(){
            this.goodsTypeGroupingName = '';
            this.searchList = [];
            this.searchActiveList = [];
            this.goodsTypeGrouping = false;
        },

        /*新增商品属性*/
        //选择形式选择重置数据
        goodsAttributesRadioChange(){
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
        },
        //输入类型选择重置数据
        textTypeChange(){
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
        },
        //添加属性
        addAttributes(){
            let data = this.goodsAttributesVal;
            data.push({name:''});
            this.goodsAttributesVal = data;
        },
        //删除对应属性
        delGoodsAttributesVal(index){
            let data = this.goodsAttributesVal;
            if(data.length==1){
                return false
            }
            data.splice(index,1)
        },
        //新增商品属性保存
        addGoodsAttributesBtn() {
            if(this.goodsAttributesName==''){
                this.$message({
                    showClose:true,
                    message:"请填写属性名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name==''){
                        this.$message({
                            showClose:true,
                            message:"请填写输入类型",
                            type:'error',
                            center:true,
                            duration:3000
                        })
                        return false
                    }
                }
            }
            let data = {
                name:this.goodsAttributesName,
                type:this.goodsAttributesRadio
            };
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                let arr = [];
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name!=''){
                        arr.push(this.goodsAttributesVal[i].name)
                    }
                }
                data.value = arr.join(',');
            }
            data.valueType = this.textTypeValue;
            if(this.textTypeValue=='NUMBER'){
                data.min = this.minVal;
                data.max = this.maxVal;
                data.unit = this.unit;
                data.unlimited = this.unlimited;
            }
            this.$ajax.post(goodsTypeGroupingAdd,data).then(res=>{
                console.log(res);
                this.goodsTypeGroupingData();
                this.addGoodsAttributesClose();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //取消
        addGoodsAttributesClose(){
            this.goodsAttributesName='';
            this.goodsAttributesRadio = 'RADIO';//选择形式
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
            this.addGoodsAttributes = false;//关闭窗口
        },


        //删除提示
        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);

            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
        //列表数据
        dataList(){
            this.$ajax.get(goodsTypeList).then(res=>{
                console.log(res);
                this.tableData = res.data;
                // this.count = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        }
    },
    // 数据观察监听
    watch: {
        page(newData,oldData){
            this.dataList();
        },
        size(newData,oldData){
            this.page = 1;
            this.dataList();
        },
        goodsTypeGroupingPage(newData,oldData){
            this.goodsTypeGroupingData();
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.dataList()
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
